import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../services/api';
import { useApp } from '../context/AppContext';
import { StatCard } from '../components/StatCard';
import { DEMO_REPORTS } from '../data/demoReports';

export function ReportsSummary() {
  const { t } = useApp();
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    api
      .get('/api/dashboard/summary')
      .then((r) => setSummary(r.data))
      .catch(() => setSummary(null));
  }, []);

  const headcount = summary?.total_employees ?? '—';
  const active = summary?.active_employees ?? '—';
  const pendingLeaves = summary?.pending_leaves ?? '—';
  const pendingExpenses = summary?.pending_expenses ?? '—';

  return (
    <>
      <section className="reports-at-a-glance panel panel--elevated">
        <h2 className="dash-section-title">{t('reportsPage.atAGlanceTitle')}</h2>
        <p className="panel__muted text-sm">{t('reportsPage.atAGlanceLeadProd')}</p>
        <div className="grid-stats reports-at-a-glance__grid">
          <StatCard icon="◎" label={t('reportsPage.agHeadcount')} value={String(headcount)} tone="success" />
          <StatCard icon="◷" label={t('reportsPage.agLeaves')} value={String(pendingLeaves)} tone="warning" />
          <StatCard icon="⧗" label={t('reportsPage.agExpenses')} value={String(pendingExpenses)} />
          <StatCard icon="◇" label={t('reportsPage.agActive')} value={String(active)} tone="accent" />
        </div>
      </section>

      <section className="reports-catalog panel panel--elevated">
        <h2 className="dash-section-title">{t('reportsPage.catalogTitle')}</h2>
        <ul className="reports-catalog__list">
          {DEMO_REPORTS.map((r) => (
            <li key={r.id} className="reports-catalog__item">
              <div>
                <strong>{r.title}</strong>
                <p className="panel__muted text-sm">{r.description}</p>
              </div>
              <span className="panel__muted text-sm">{r.format}</span>
            </li>
          ))}
        </ul>
        <p className="panel__muted text-sm">
          <Link to="/reports?tab=analytics">{t('reportsPage.openAnalytics')}</Link>
        </p>
      </section>
    </>
  );
}
